import {
  tryEncodeDate,
  getDay,
  getMonthText,
  decDay,
  getDate,
} from '../../../../../../Utils/dateUtils';
import { format } from 'date-fns';
import { IFormData } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { StatistikrapporteringAldersindelningQuery_db_BOAldersindelning_All } from '../Queries/_QueryTypes/StatistikrapporteringAldersindelningQuery';
import { StatistikrapporteringQuery_node_TEDBOAktivitet } from '../Queries/_QueryTypes/StatistikrapporteringQuery';

export const selectValue = (
  newValue: number | null | undefined,
  oldValue: number | null | undefined
) =>
  newValue !== undefined ? newValue : oldValue !== undefined ? oldValue : null;

export const initAktGiltigaAldrar = (
  nodeData: StatistikrapporteringQuery_node_TEDBOAktivitet | null | undefined,
  allaAldrar: StatistikrapporteringAldersindelningQuery_db_BOAldersindelning_All[]
) => {
  let aldrar: StatistikrapporteringAldersindelningQuery_db_BOAldersindelning_All[] =
    [];
  let aktAlderData = nodeData?._Associations?.AktAlderindelning;
  if (aktAlderData) {
    for (let i = 0; i < allaAldrar.length; i++) {
      let alder = allaAldrar[i];
      if (
        nodeData?.FRANDATUM >= alder?.FRANDATUM &&
        nodeData?.FRANDATUM <= alder?.TILLDATUM
      ) {
        aldrar.push(alder);
      }
    }
  }
  return aldrar;
};

export const aktuellaAldrar = (
  values: IFormData,
  nodeData: StatistikrapporteringQuery_node_TEDBOAktivitet | null | undefined
): Record<string, number> => {
  let oldvalues = nodeData?._Associations?.AktAlderindelning;
  let aldrar: Record<string, number> = {};
  if (oldvalues) {
    for (let i = 0; i < oldvalues.length; i++) {
      let oldvalue = oldvalues[i];
      if (oldvalue._Associations?.Aldersindelning?.id) {
        aldrar[oldvalue._Associations?.Aldersindelning?.id] =
          oldvalue.ANTAL ?? 0;
      }
    }
  }
  for (let key in values.aldrar) {
    if (key) {
      aldrar[key] = (values.aldrar as Record<string, number>)[key];
    }
  }
  return aldrar;
};

export const formatSwedishDate = (dateStr: string): string => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = tryEncodeDate(year, month, day);
  if (!date) return '';
  return `${getDay(date)} ${getMonthText(month)}`;
};

export function getDateString(offsetDays: number): string {
  const date = decDay(getDate(), offsetDays);
  if (!date || isNaN(date.getTime())) return '';
  return format(date, 'yyyy-MM-dd');
}

export const formatDayLabel = (
  date: string,
  todayStr: string,
  yesterdayStr: string
): string => {
  const formatted = formatSwedishDate(date);
  if (date === todayStr) return `Idag ${formatted}`;
  if (date === yesterdayStr) return `Igår ${formatted}`;
  return formatted;
};
